import { Component } from '@angular/core';
import { SharedService } from '@shared/services/shared.service';

@Component({
  selector: 'app-pay-online-failure',
  templateUrl: './pay-online-failure.component.html'
})

export class PayOnlineFailureComponent {

  public processing: boolean = false;
  public isValid: boolean = true;


  constructor(public sharedService: SharedService) { }
}


